import React, { useEffect, useState } from 'react';
import OftadehLayout from '../../components/OftadehLayout/OftadehLayout';
import { Button, CircularProgress, Grid, makeStyles, Typography } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import axiosInstance from '../../constants/AxiosInstance';
import { API_URL, BASE_IMG_URL, getTypeName, NOTICE_CATEGORY } from '../../constants';
import swal from '@sweetalert/with-react';
import { getNoticeList, getNoticeManagerList } from '../../constants/PromiseHttp';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  my3: {
    margin: '1.3rem 0',
  },
  mb0: {
    marginBottom: 0,
  },
  mRight: {
    marginRight: '.85rem',
  },
  p1: {
    padding: '.85rem',
  },
}));

const NoticeListPage = (props) => {
  const { history } = props;
  const classes = useStyles();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const IS_SYS_ADMIN = sessionStorage.getItem('bt_role') === 'SYS_ADM';

  const rowClick = (data) => {
    //console.log(data[0]);
    history.push(`/pages/notice/detail?type=edit&id=${data[0]}`);
  };

  const rowDelete = (row) => {
    let ids = [];
    row.data.map((r) => {
      ids.push(data[r.dataIndex].id);
      return r;
    });
    let delParam = {
      ids: ids.toString(),
    };
    swal({
      title: 'Are you sure you want to delete?',
      text: '',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        axiosInstance.post(`${API_URL}/notice/deleteIds`, delParam, { headers: { Pragma: 'no-cache' } }).then((response) => {
          swal('It is deleted.', {
            icon: 'success',
          });
          getData();
        });
      } else {
        getData();
      }
    });
  };

  const options = {
    print: false,
    filter: false,
    filterType: 'checkbox',
    selectableRows: 'multiple',
    viewColumns: false,
    download: false,
    onRowClick: rowClick,
    onRowsDelete: rowDelete,
  };

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setLoading(true);

    if (sessionStorage.getItem('bt_role') === 'SYS_MGR') {
      getNoticeManagerList(sessionStorage.getItem('bt_user')).then((result) => {
        setLoading(false);
        setData(result);
      });
    } else {
      getNoticeList().then((result) => {
        setLoading(false);
        setData(result);
      });
    }
  };

  const cols = [
    {
      name: 'id',
      label: 'id',
      options: {
        filter: false,
        sort: true,
        display: false,
        viewColumns: false,
      },
    },
    // {
    //   name: 'id',
    //   label: 'No.',
    //   options: {
    //     filter: false,
    //     sort: true,
    //     display: true,
    //     viewColumns: false,
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return tableMeta.rowIndex + 1;
    //     },
    //   },
    // },
    {
      name: 'category',
      label: 'Category',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return getTypeName(NOTICE_CATEGORY, value);
        },
      },
    },
    // {
    //   name: 'languageId',
    //   label: 'Language',
    //   options: {
    //     filter: false,
    //     sort: true,
    //   },
    // },
    {
      name: 'thumb',
      label: 'Photo',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          //console.log(value);
          if (value && value.length > 0) {
            const url = `${BASE_IMG_URL}` + value[0].key;

            return <img src={url} width={120} alt={value[0].name} />;
          } else {
            return <img src={'/images/noImg.png'} width={120} />;
          }
        },
      },
    },
    {
      name: 'title',
      label: 'Title',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'createdAt',
      label: 'Registration Date',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return moment(Number(value)).format('YYYY-MM-DD HH:mm');
        },
      },
    },
    {
      name: 'viewCnt',
      label: 'View Count',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value || 0;
        },
      },
    },
  ];

  return (
    <OftadehLayout>
      <Grid container className={classes.my3} alignItems="center">
        <Grid item className={classes.mRight} style={{ fontWeight: 'bold' }}>
          <Typography variant="h5" component="h1" style={{ fontWeight: 'bold' }}>
            Notice List
          </Typography>
        </Grid>
        {IS_SYS_ADMIN && (
          <Grid item>
            <Button onClick={() => history.push('/pages/notice/edit?type=new')} variant="outlined" color="primary" size="small">
              Registration
            </Button>
          </Grid>
        )}
      </Grid>
      {/*<OftadehBreadcrumbs path={history} />*/}
      <MUIDataTable title={''} data={data} columns={cols} options={options} />
      {loading && (
        <div style={{ position: 'fixed', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', zIndex: 999 }}>
          <CircularProgress color={'secondary'} />
        </div>
      )}
    </OftadehLayout>
  );
};

export default NoticeListPage;
